export enum PriceListEnums{
    base = 1
}